import {
  QuestionBase,
  QuestionControlOptions
} from '../question-types/question-base';

export type TextboxType =
  | ''
  | 'text'
  | 'password'
  | 'email'
  | 'number'
  | 'date'
  | 'time'
  | 'tel'
  | 'url';

export interface TextboxControlOptions<T = string>
  extends QuestionControlOptions<T> {
  type?: TextboxType;
  maxLength?: number;
  placeholder?: string;
}

export class TextboxQuestion<T = string> extends QuestionBase<T>
  implements TextboxControlOptions<T> {
  controlType = 'textbox';
  type: TextboxType;
  // Works only for string types (text, search, url, tel, email, and password) [https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input#attr-maxlength]
  maxLength: number;
  minLength: number;
  placeholder?: string;

  constructor(options: TextboxControlOptions<T>) {
    super(options);
    this.type = options['type'] || '';
    this.maxLength = options.maxLength || null;
    this.placeholder = options.placeholder || '';
  }
}
